export const regionHelpers = {
  data() {
    return {
      regions: {
        "Все": [139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 383, 1003, 1042, 1046],
        "Европа": [140, 150, 151, 154, 158, 159, 161, 167, 168, 169, 170, 183, 186, 187, 188, 191, 199, 201, 207, 208, 210, 211, 213, 216, 217, 230, 231, 232, 233, 235, 236, 239],
        // "Азия": [141, 147, 148, 157, 160, 162, 163, 164, 165, 166, 171, 173, 175, 176, 177, 178, 182, 184, 185, 192, 198, 200, 202, 203, 204, 212, 214, 215, 219, 220, 222, 223, 226, 228, 237, 242, 383],
        "Африка": [143, 144, 189, 190, 193, 221, 224, 240, 241],
        "Америка": [146, 152, 153, 156, 179, 180, 194, 205, 206, 218, 227, 234],
        // "Океания": [139, 200],
      }, 
      refreshers: {
        'set_countries_of_branches_ids': 0,
        'set_countries_of_rolling_stock_ids': 0,
        'set_uploading_geography_ids': 0,
        'set_unloading_geography_ids': 0,
        'segments_by_countries': 0
      }     
    }
  },
  methods: {
    selectRegionCountries(countries, param) {
      let selected = new Set();

      if (this.editedItemLocal && this.editedItemLocal.hasOwnProperty(param)) {
        selected = new Set(this.editedItemLocal[param]);
      } else if (this.editedItem && this.editedItem.hasOwnProperty(param)) {
        selected = new Set(this.editedItem[param]);
      }      
  
      // Check if all countries in the region are already selected
      const allSelected = countries.every((country) => selected.has(country));
  
      if (allSelected) {
        // Remove the countries if all are selected
        countries.forEach((country) => selected.delete(country));
      } else {
        // Add the countries if not all are selected
        countries.forEach((country) => selected.add(country));
      }
  
      if (this.editedItemLocal && this.editedItemLocal.hasOwnProperty(param)) {
        this.editedItemLocal[param] = Array.from(selected);
      } else if (this.editedItem && this.editedItem.hasOwnProperty(param)) {
        this.editedItem[param] = Array.from(selected);
      }

      this.refreshers[param]++;
    },    
  }
}